<div class="nacha-results-step">
  <!-- Summary cards -->
  <div class="results-summary">
    <div class="summary-card success-card">
      <mat-icon>check_circle</mat-icon>
      <span class="count">{{ successfulResults.length }}</span>
      <span class="label">Successful</span>
    </div>
    <div class="summary-card failed-card">
      <mat-icon>error</mat-icon>
      <span class="count">{{ failedResults.length }}</span>
      <span class="label">Failed</span>
    </div>
    <div class="summary-card skipped-card">
      <mat-icon>skip_next</mat-icon>
      <span class="count">{{ skippedMatches.length }}</span>
      <span class="label">Skipped</span>
    </div>
    <div class="summary-card total-card">
      <mat-icon>attach_money</mat-icon>
      <span class="count">{{ totalAmount | currency }}</span>
      <span class="label">Collected</span>
    </div>
  </div>

  <!-- Successful payments -->
  @if (successfulResults.length > 0) {
    <div class="results-table-section">
      <h4>
        <mat-icon class="section-icon success">check_circle</mat-icon>
        Successful Payments ({{ successfulResults.length }})
      </h4>
      <table mat-table [dataSource]="successfulResults" class="results-table">
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let result">
            <mat-icon [class]="getStatusClass(result.status)">{{ getStatusIcon(result.status) }}</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="individualId">
          <th mat-header-cell *matHeaderCellDef>Individual ID</th>
          <td mat-cell *matCellDef="let result">{{ result.match.row.individualIdNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef>Customer</th>
          <td mat-cell *matCellDef="let result">
            {{ result.match.customer?.displayName || result.match.customer?.companyName || result.match.row.individualName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let result">{{ result.match.row.amount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="txType">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let result">{{ result.match.row.transactionTypeLabel }}</td>
        </ng-container>
        <ng-container matColumnDef="transactionId">
          <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
          <td mat-cell *matCellDef="let result">{{ result.transactionId }}</td>
        </ng-container>
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef>Message</th>
          <td mat-cell *matCellDef="let result">{{ result.responseMessage }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let result">
            @if (result.transactionId) {
              <button mat-icon-button matTooltip="View Receipt" (click)="onViewReceipt(result.transactionId)">
                <mat-icon>receipt</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Download Receipt" (click)="onDownloadReceipt(result.transactionId)">
                <mat-icon>download</mat-icon>
              </button>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  }

  <!-- Failed payments -->
  @if (failedResults.length > 0) {
    <div class="results-table-section">
      <h4>
        <mat-icon class="section-icon error">error</mat-icon>
        Failed Payments ({{ failedResults.length }})
      </h4>
      <table mat-table [dataSource]="failedResults" class="results-table">
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let result">
            <mat-icon [class]="getStatusClass(result.status)">{{ getStatusIcon(result.status) }}</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="individualId">
          <th mat-header-cell *matHeaderCellDef>Individual ID</th>
          <td mat-cell *matCellDef="let result">{{ result.match.row.individualIdNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef>Customer</th>
          <td mat-cell *matCellDef="let result">
            {{ result.match.customer?.displayName || result.match.customer?.companyName || result.match.row.individualName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let result">{{ result.match.row.amount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="txType">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let result">{{ result.match.row.transactionTypeLabel }}</td>
        </ng-container>
        <ng-container matColumnDef="transactionId">
          <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
          <td mat-cell *matCellDef="let result">{{ result.transactionId }}</td>
        </ng-container>
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef>Error</th>
          <td mat-cell *matCellDef="let result" class="error-message-cell">{{ result.error || result.responseMessage }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let result"></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  }

  <!-- Skipped -->
  @if (skippedMatches.length > 0) {
    <div class="results-table-section skipped-section">
      <h4>
        <mat-icon class="section-icon skip">skip_next</mat-icon>
        Skipped ({{ skippedMatches.length }})
      </h4>
      <p class="skipped-note">These entries were not processed — either excluded by the include checkbox, no customer matched, or no ACH token was available.</p>
    </div>
  }
</div>
